import { pushApiSubscriptionKeys } from '../config/initialValues/pushApiSubscriptionInitialValues';

export function removeIds(obj) {
    return JSON.parse(
        JSON.stringify(obj, (key, value) => {
            if (key === 'id') return undefined;
            return value;
        })
    );
}

export function cleanupSubscription(subscription) {
    return JSON.parse(
        JSON.stringify(subscription, (key, value) => {
            if (key === '' || pushApiSubscriptionKeys.includes(key)) {
                return value;
            }
            if (value && typeof value === 'object') {
                return value;
            }
            return undefined;
        })
    );
}
